import React from "react";
import { useSelector } from "react-redux";
import { InfiniteList2 } from "../../../../../../common/components";
import { CollapseNodes } from "./components/toc-dropdown/components";
import styles from "./MultiToc.module.css";

const MultiToc = ({ open, infiniteListRequest }) => {
	const multiDocs = useSelector(({ srProjectDocument }) => srProjectDocument.multiDocs);
	return (
		<>
			<div className={styles.container} data-closed={!open} id="tour-review-document-list">
				<div className={styles.scrollcontainer}>
					<InfiniteList2
						anticipate
						className={styles.list}
						request={infiniteListRequest}
						rowRenderer={(toc) => (
							<CollapseNodes
								key={toc.id}
								document={multiDocs?.contents?.find((doc) => doc.id === toc.id) || toc}
							/>
						)}
					/>
				</div>
			</div>
		</>
	);
};
export default MultiToc;
